import { AccountDetailsErrorWSMessage, FileDismissWSMessage, ImportCitationWSMessage, NewImportWSMessage, StudyUpdateWSMessage, UpdateWSEventStatePayload, WEBSOCKET_EVENTS, WebSocketState } from '@/store/modules/websocket/websocket.types';
import { MutationTree } from 'vuex';

export const webSocketMutations: MutationTree<WebSocketState> = {
    WS_CONNECTION_STATUS_MUTATION(state: WebSocketState, isConnected: boolean) {
        state.isConnected = isConnected;
    },
    WS_RECONNECTED_MUTATION(state: WebSocketState) {
        state.wsReconnectedCount += 1;
    },
    WS_UPDATE_EVENT_MUTATION(state: WebSocketState, payload: UpdateWSEventStatePayload) {
        const { event, message } = payload;

        switch (event) {
            case WEBSOCKET_EVENTS.IMPORT_CITATIONS_EVENT:
                state.importCitationEventState = <ImportCitationWSMessage>message;
                break;
            case WEBSOCKET_EVENTS.NEW_IMPORT_EVENT:
                state.newImportEventState = <NewImportWSMessage>message;
                break;
            case WEBSOCKET_EVENTS.FILE_DISMISS_EVENT:
                state.fileDismissEventState = <FileDismissWSMessage>message;
                break;
            case WEBSOCKET_EVENTS.STUDY_UPDATE_EVENT:
                state.studyUpdateEventState = <StudyUpdateWSMessage>message;
                break;
            case WEBSOCKET_EVENTS.ACCOUNT_DETAILS_ERROR_EVENT:
                state.accountDetailErrorEventState = <AccountDetailsErrorWSMessage>message;
            default:
                break;
        }
    }
};